import { render, staticRenderFns } from "./korpay.vue?vue&type=template&id=67487d1e&scoped=true&"
import script from "./korpay.vue?vue&type=script&lang=js&"
export * from "./korpay.vue?vue&type=script&lang=js&"
import style0 from "./korpay.vue?vue&type=style&index=0&id=67487d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67487d1e",
  null
  
)

export default component.exports